import { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import BlockHeader from '../BlockHeader';
import Button from '../Button';
import PrivateGameDialog from './PrivateGameDialog';

import usersIcon from '../../assets/icons/play-together/users.svg';
import lockIcon from '../../assets/icons/play-together/lock.svg';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const PlayTogetherCard = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    background: ${color.grayscale[1000]};
    padding: 20px 32px 20px 24px;
    border-radius: 16px;
    box-shadow: ${shadow.regular};
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (min-width: 1024px) and (max-width: 1279px) {
      padding: 20px 16px 20px 12px;
    }
  `;
});

const SectionText = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    display: inline-block;
    flex-grow: 2;
    font-size: ${type.size.regular};
    font-weight: ${type.weight.bold};
    margin-left: 1rem;
    color: ${color.grayscale[0]} 
  `;
});

const Img = styled.img`
  display: inline-block;
  max-width: 64px;
  width: 15%;
`;

const CtaButton = styled(Button)(({ theme }) => {
  const { color } = theme;

  return `
    background: ${color.grayscale[1000]};
    border: 2px solid ${color.secondary.regular};
    color: ${color.secondary.regular};
    white-space: nowrap;

    @media screen and (min-width: 1024px) and (max-width: 1279px) {
      padding: 7px 16px;
    }

    &:hover {
      background: ${color.secondary.regular} !important;
      color: ${color.grayscale[1000]};
    }
  `;
});

const StyledLink = styled(Link)(({ theme }) => {
  const { color } = theme;
  return `
  background: ${color.grayscale[1000]};
  border: 2px solid ${color.secondary.regular};
  color: ${color.secondary.regular};
  white-space: nowrap;
  border-radius: 1000px;
  padding: 10px 24px;
  text-decoration: none;
  font-size: 0.875rem;

  &:focus, &:hover, &:visited, &:link, &:active {
    text-decoration: none;
  }

  @media screen and (min-width: 1024px) and (max-width: 1279px) {
    padding: 7px 16px;
  }

  &:hover {
    background: ${color.secondary.regular};
    color: ${color.grayscale[1000]};
  }
  `;
});

const PlayTogetherSection = (props) => {
  const { location } = props;
  const [isPrivateGameDialogVisible, updatePrivateGameDialogShowStatus] = useState(false);

  const hidePrivateGameDialog = () => {
    updatePrivateGameDialogShowStatus(false);
  };

  const showPrivateGameDialog = () => {
    updatePrivateGameDialogShowStatus(true);
  };

  return (
    <section>
      <BlockHeader>Play Together</BlockHeader>

      <Grid>
        <PlayTogetherCard>
          <Img src={usersIcon} alt="" />
          <SectionText>Group Play</SectionText>
          <StyledLink to={{ pathname: `/play/group-play`, state: { from: location.pathname } }}>Join Game</StyledLink>
        </PlayTogetherCard>

        <PlayTogetherCard>
          <Img src={lockIcon} alt="" />
          <SectionText>Private Game</SectionText>

          <CtaButton rounded type="button" onClick={showPrivateGameDialog}>
            Create a Game
          </CtaButton>
        </PlayTogetherCard>

        <PrivateGameDialog
          closeCallback={hidePrivateGameDialog}
          isOpen={isPrivateGameDialogVisible}
        ></PrivateGameDialog>
      </Grid>
    </section>
  );
};

export default withRouter(PlayTogetherSection);
